// extracted by mini-css-extract-plugin
export default {"header":"WaterTreatmentPlant_header__JXoX5","content":"WaterTreatmentPlant_content__GBcQL","divider":"WaterTreatmentPlant_divider__hGzlb"};